import React from 'react';
import EmojiEmotionsIcon from '../../../assets/images/ico-smile-bk.svg';
import SignalCellularAltIcon from '../../../assets/images/ico-chart-bk.svg';
import ApartmentIcon from '../../../assets/images/ico_company.svg';
import DescriptionIcon from '../../../assets/images/ico_news.png';
import styles from '../../../assets/styles/modules/Ranking.module.css';


const Ranking = ({ranking, nameClick, themeCodeClick, reactClick}) => {
    const path = window.location.pathname.split('/');
    const isIndustry = path[1] === 'industry'


    return (
        <div className={styles.container}>
            <div className={styles.head}>
                <p>{isIndustry ? '산업' : '테마'} 순위</p>
                <p className={styles.explain}>*긍정/부정 뉴스를 보도한 기업의 수가 가장 많은 {isIndustry ? '산업' : '테마'} 순위입니다.</p>
            </div>
            {ranking && ranking.map((rank, idx) => {
                    const gubun = rank.gubun > 0 ? ['긍정', '상승'] : ['부정', '하락'];
                    const contentsClick = () => {
                        reactClick(gubun)
                        if (isIndustry) {
                            nameClick(rank.FICS_sub)
                        } else {
                            nameClick(rank.theme_name)
                            themeCodeClick(rank.theme_code)
                        }
                    }

                    return (
                        <div className={styles.contents} onClick={contentsClick}>
                            <p className={styles.rank_name}>
                                <span>0{rank.rank} </span>
                                <span className={rank.gubun > 0 ? `${styles.positive}` : `${styles.negative}`}>{isIndustry ? rank.FICS_sub : rank.theme_name}</span>
                            </p>
                            <p >
                                <img src={EmojiEmotionsIcon} alt='icon'/>
                                {gubun[0]}뉴스 {isIndustry && rank.gubun > 0 ? rank.groupsentnewscnt : rank.groupsentnewscnt}개
                            </p>
                            <p>
                                <img src={SignalCellularAltIcon} alt='icon'/>
                                주가 {gubun[1]} 기업 {isIndustry ? rank.groupstockcnt : rank.groupstockcnt}개
                            </p>
                            <p>
                                <img src={ApartmentIcon} alt='icon'/>
                                {gubun[0]}뉴스를 보도한 기업 {isIndustry ? rank.groupstockcnt : rank.groupstockcnt}개
                            </p>
                            <p className={styles.subject}>
                                <img src={DescriptionIcon} alt='icon'/>{rank.newsinfo.subject}
                            </p>
                        </div>
                    )
                }
            )}
        </div>
    );
};

export default Ranking;